import { globalTypes } from '../reduxExports';

const screens = ['chargers', 'alarms', 'parameters', 'customers', 'users', 'org', 'roles','chargingStations','configureNotification','ruleEngine','ruleEngineHistory','executionSummaryRuleEngineForm','uptimeReports'];
const initialObject = {
  columnOrders: [],
  columnDimensions: undefined,
  columnVisibilityModel: undefined
};

export const userTableColumnPrefrencesInitialState: ITableColumnPrefrences[] = screens.map(screen => ({
  screen,
  ...initialObject
} as ITableColumnPrefrences));


const globalDataInitialState: GlobalDataState = {
  toggleExpandedIds: [],
  screenTableColumnPrefrences: userTableColumnPrefrencesInitialState,
  setupDefaultFilterConfig: true,
  hideSideBar: false,
  acAndDcToggleState:null,
};

const globalReducer = (state: GlobalDataState = globalDataInitialState, action: GlobalDataAction): GlobalDataState => {
  switch (action.type) {
    case globalTypes.SET_TOGGLE_IDS:
      return {
        ...state,
        toggleExpandedIds: action.toggleExpandedIds,
      };
    case globalTypes.SET_TABLE_COLUMN_PREFRENCES:
      return {
        ...state,
        screenTableColumnPrefrences: action.screenTableColumnPrefrences
      }
    case globalTypes.SET_DEFAULT_FILTER_CONFIG_FLAG:
        return {
          ...state,
          setupDefaultFilterConfig: action.setupDefaultFilterConfig
      }
    case globalTypes.SET_SIDEBAR_STATE:
      return{
        ...state,
        hideSideBar: action.hideSideBar
      }
      case globalTypes.SET_AC_AND_DC_TOGGLE_STATE:
        return{
          ...state,
          acAndDcToggleState: action.acAndDcToggleState
        }
    default:
      return state;
  }
};


export default globalReducer;
